import styled, { css, keyframes } from 'styled-components';
import { Card, BREAKPOINTS } from '@manulife/mux';

//// TO-DO - implement media specific dynamic formatting
// https://jira.manulife.ca/browse/CDTMP-197
// https://jira.manulife.ca/browse/CDTMP-192
const media = Object.keys(BREAKPOINTS).reduce((acc, label) => {
    acc[label] = (...args) => css`
        @media (max-width: ${BREAKPOINTS[label] / 16}em) {
            ${css(...args)}
        }
    `;
    return acc;
}, {});

export const pulseKeyframes = keyframes`
0% {
  opacity: 0.6;
}
20% {
  opacity: 1;
}
30% {
  opacity: 0.6;
}
50% {
  opacity: 1.0;
}
60% {
  opacity: 0.6;
}
100% {
  opacity: 0.6;
}
`;

export const RootWrapper = styled.div`
    animation: ${pulseKeyframes} 2s infinite;
    width: 100%;
`;

export const ScreenReaderOnly = styled.span`
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 30px;

    ${media.DESKTOP_SM`
        display: block;
        button {
            display: block;
            width: 100%;
            margin-bottom: 20px;
        }
    `}
`;

export const EmailButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 60px;

    ${media.DESKTOP_SM`
        display: block;
        button {
            display: block;
            width: 100%;
            margin-bottom: 20px;
        }
    `}
`;

export const CardGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 30px;
    ${media.DESKTOP_SM`
        display: block;
    `}
`;

export const PaddedCard = styled(({ children, id }) => (
    <Card id={id} customStyle={{ cardStyle: { marginBottom: '20px' } }}>
        {children}
    </Card>
))`
    margin-bottom: 20px;
`;

export const CardHeaderFlex = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`;

export const PaddedFields = styled.div`
    display: flex;
    ${media.TABLET_PORTRAIT`
        display: block;
    `}
`;

export const CheckboxWrapper = styled.div`
    display: flex;
    margin-top: 32px;

    p {
        margin-top: 0;
    }
`;

export const FamilyCheckboxWrapper = styled.div`
    display: flex;
    margin-top: 20px;

    p {
        margin-top: 0;
    }
`;

export const ErrorMsg = styled.div`
    color: #db1f00;
`;

export const FlexWrapper = styled.div`
    display: flex;
`;

export const InfoMessageWrapper = styled.div`
    p {
        margin-top: 0;
    }
`;

export const List = styled.ul`
    padding-left: 20px;
    margin-top: 0px;
`;

export const Tag = styled.span`
    background-color: #e5e5e8;
    padding: 4px 8px;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
`;

export const TextInputWrapper = styled.div`
    margin-top: 12px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
    row-gap: 20px;
    ${media.TABLET_PORTRAIT`
        display: block;
        > * {
            margin-top: 12px;
        }
    `}
`;

export const AddButtonWrapper = styled.div`
    margin-top: 40px;
`;

export const ValidationAlertWrapper = styled.div`
    margin-bottom: 20px;
`;

export const BoldLabel = styled.strong`
    display: block;
    margin-top: ${({ noMarginTop }) => (noMarginTop ? '0px' : '16px')};
`;
